


<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" :timeout="timeout" app right>
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout px-3 px-md-0 justify-center pt-5 wrap py-lg-4>
      <v-flex md11 lg9>
        <div class="RM clr">SELLER PORTAL</div>
        <div class="head">Sold Details</div>
        <div>
          <span class="RB">OrderId</span>
          <span style="color: green"> #{{odrid}}</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center px-3 px-md-0>
      <v-flex md11 lg9>
        <v-layout wrap>
          <v-flex xs12 md8>
            <v-layout wrap  py-2>
              <v-flex xs12 sm2 md2 pb-3 pb-md-0>
                <v-img v-if="orderDetails.productId.photos[0].length <1"
                  height="150px"
                  width="150px"
                  cover
                  src="../../assets/images/f1.png"
                >
                </v-img>
                <v-img v-else
                  height="150px"
                  width="150px"
                  cover
                  :src="mediaURL  + orderDetails.productId.photos[0] "
                >
                </v-img>
              </v-flex>
              <v-flex xs12 sm10 align-self-center>
                <v-layout wrap pl-lg-3>
                  <v-flex sm4 lg5>
                    <div class="medium clr RG">Product Name</div>
                    <div class="RB medium">{{orderDetails.name}}</div>
                  </v-flex>
                  <v-flex xs4 sm3 md2>
                    <div class="medium clr RG">Quantity</div>
                    <div class="RB medium">{{orderDetails.quantity}} kg</div>
                  </v-flex>
                  <v-flex xs3 sm2 md2>
                    <div class="medium clr RG">Total</div>
                    <div class="RB medium">₹{{orderDetails.productTotalAmount}}</div>
                  </v-flex>
                  <v-flex xs6 sm2 md2 pt-3 pt-sm-0>
                    <!-- <v-btn
                      tile
                      color="#FEBD08"
                      :href="
                        baseURL +
                        '/order/invoice/pdf?orderid=' +
                        orderId +
                        '&productid=' +
                        item._id
                      "
                    >
                      Invoice
                    </v-btn> -->
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-4 pr-lg-1>
                <v-divider> </v-divider>
              </v-flex>
              <v-flex xs12 pt-2> <span class="RB">Rate this Product</span></v-flex>
              <v-flex xs12 md3 lg3>
              <v-rating background-color="yellow" color="yellow"  v-model="rate" >
              </v-rating>
              </v-flex>
               <v-flex xs12 pr-md-1 py-3>
                <v-textarea v-model="feedback" style="border-radius:1px" label="Write a Review"  >

                </v-textarea>
              </v-flex>
              <v-flex xs12 py- pb-lg-6 pr-1 tile>
                <v-btn dense width="100%" @click="addRating" color="#FEBD08">
                    Add
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4 style="border-left: 1px solid #d5d5d5">
            <v-layout wrap px-3 py-5>
              <v-flex xs12 class="RB medium" pb-5> ADDRESS </v-flex>
              <v-flex xs12 class="RB medium" pb-3> {{address.firstName}} {{address.lastName}}</v-flex>
              <v-flex xs12 class="RB medium" pb-3
                >{{address.address}}
              </v-flex>
              <v-flex xs12 pb-2>
                <span style="padding-right: 2%"
                  ><v-icon color="#FEBD08">mdi-phone-outline</v-icon></span
                >
                <span>{{address.phone}}</span>
              </v-flex>
              <v-flex xs12 pb-3>
                <span style="padding-right: 2%"
                  ><v-icon color="#FEBD08">mdi-email-outline</v-icon></span
                >
                <span>{{address.email}}</span>
              </v-flex>
              <v-flex xs12 pt-5>
                <v-layout wrap>
                  <v-flex xs6 class="regulartext">Subtotal </v-flex>
                  <v-flex xs6 text-right class="RM">Rs.{{subTotal}} </v-flex>
                  <v-flex xs6 class="regulartext">Shipping</v-flex>
                  <v-flex xs6 text-right class="RM">Free</v-flex>
                  <v-flex xs12 py-3>
                    <v-divider> </v-divider>
                  </v-flex>
                  <v-flex xs6 class="regulartext">Total </v-flex>
                  <v-flex xs6 text-right class="RM" style="font-size: 23px"
                    >Rs.{{totalAmount}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      rate :null,
      appLoading: false,
      snackbar: false,
      msg: "",
      feedback:"",
      orderDetails: [],
      address:[],
      subTotal:"",
      totalAmount:"",
      sellerid:"",
      odrid:""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading =true;
      axios({
        method: "post",
        url: "/my/order/product/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          orderid: this.$route.query.orderid,
          productid: this.$route.query.product,
        },
      }).then((response) => {
        if (response.data.status) {
          this.orderDetails = response.data.product;
          this.address = response.data.orderDetails.billingAddress;
          this.subTotal = response.data.orderDetails.subTotal;
          this.totalAmount = response.data.orderDetails.totalAmount;
          this.sellerid = response.data.product.sellerId._id;
          this.odrid = response.data.orderDetails.orderID
        }
        this.appLoading = false;
      });
    },
    addRating()
    {
       this.appLoading =true;
         axios({
        method: "post",
        url: "/rating/add/update",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data:
        {
          ratingType:"seller",
          sellerId :this.sellerid,
          rating:this.rate,
          review:this.feedback

        }
         })
         .then((response) =>{
             if(response.data.status)
             {
              this.snackbar =true;
              this.msg =response.data.msg;
             }
             this.appLoading =false;
         })

    }
  },
};
</script>